/* istanbul ignore file */
import apiInterface from 'shared/helpers/apiInterface';

export default {
  host: process.env.NODE_ENV === 'development' ? 'https://api.preproduction.bukalapak.com/' : '/',
  apiInterface,
  withId: true,
  withData: true,
};
